/*import {
  Absence,
  Alert,
  ClaimLink,
  Disability,
  Payment,
  Policy,
  PolicyCalc,
  SearchResult,
} from 'src/app/shared';
import {
  ClientMessage,
  Companion,
  Vehicle,
} from 'src/app/shared/models/search-result';
*/
import { UserActions } from 'src/app/shared/models/user';
//} from './user';

export class CommCenterMessage {
  detailId: number;
  correlationId: string;
  messageId: string;
  value: string;
  sender: string;
  date: Date;
  unread: boolean;
  read: boolean = false;
  examiner: boolean;
}

export class SendMessage {
  messageId: string;
  messageText: string;
  includeIndirects: boolean;
  userActions: UserActions;
  userOwns?: boolean;
  empUNum?: string;
  claimNumber: string;
  examinerName?: string;
  createdTS: Date;
  authorization?: string;
  initials?: string;
  procUnit?: string;
  vendorId?: string;
  formType?: string;
}

export class SaveMessageResponse {
  messageId: string;
  name: string;
  date: Date;
  alertId: number;
  unread: boolean;
}
/*class ConversationSummary implements SearchResult {
  client: string = '';
  empId: string = '';
  employeeId: string = '';
  openDate: string = '';
  status: string;
  subStatus: string = '';
  userClaim: boolean = false;
  payments: Payment[] = [];
  activity: Alert[] = [];
  notifications: Alert[] = [];
  policyCalcs: PolicyCalc[] = [];
  policies: Policy[] = [];
  results: SearchResult[] = [];
  absence: Absence;
  disability: Disability;
  lob: string;
  linkedClaims: ClaimLink[];
  isLiabilityClaim: boolean;
  lossDate: string;
  lossState: string;
  anticipatedReturnToWorkDuty: string;
  anticipatedReturnToWorkDate: string;
  workStatus: string;
  exPolicy: string;
  lobDescription: string;
  type: string;
  vehicleInfo: Vehicle;
  listClientMessage: ClientMessage[];
  examinerName: string;
  examinerEmail: string;
  claimant: string;
  vendorId: string;
  procUnit: string;
  stateofJurisdiction: string;
  carrierCode: string;
  paidTotal: string;
  source: string;
  claimDescription: string;
  claimNumber: string;
  claimId: string;
  contNum: string;
  isDisableAddToWatchList: boolean;
  userOwns: boolean;
  name: string;
  date: Date;
  unread: boolean;
  messageId: string;
  examinerPhoneNumber: string;
  claim: SearchResult;
  details: CommCenterMessage[];
  causedBy: string;
  companionClaims: Companion[];
  absenceSubstatus: string;
  isIntermittent: boolean;
  claimLabel: string;
}*/

export class SaveMessageActionRequest {
  MessageId: string;
  CorrelationId: string;
  Action: string;
  ReadBy: string;
  ConversationDetailId: number;
  SourceSystem: string;
  ContNum: string;
  ClaimNumber: string;
}
